// src/resources/sections/dnsConfig.ts
import type { ResourceConfig } from "../resourceTypes";

export const DNS_CONFIG: ResourceConfig[] = [
  {
    name: "domains",
    label: "Domains",
    schema: "dns",
    fields: [
      {
        source: "name",
        label: "name",
        kind: "longtext",
        list: true,
        form: true,
      },
      {
        source: "master",
        label: "master",
        kind: "longtext",
        list: true,
        form: true,
      },
      {
        source: "type",
        label: "type",
        kind: "select",
        list: true,
        form: true,
        choices: [{ value: "NATIVE", label: "NATIVE" }],
        defaultValue: "pem", // carrying over your original default
      },
      {
        source: "account",
        label: "account",
        kind: "longtext",
        list: true,
        form: true,
      },
      {
        source: "created_at",
        label: "created_at",
        kind: "date",
        list: true,
        form: false,
        editDisabled: true,
      },
      {
        source: "updated_at",
        label: "updated_at",
        kind: "date",
        list: true,
        form: false,
        editDisabled: true,
      },
    ],
    searchFields: ["name", "master"],
  },

  {
    name: "v_records",
    label: "V Records",
    schema: "dns",
    fields: [
      {
        source: "domain_id",
        label: "domain_id",
        kind: "uuid",
        form: true,
        list: false,
        ref: {
          resource: "domains",
          optionText: "name",
          input: "autocomplete",
          schema: "dns",
        },
      },
      {
        source: "name",
        label: "name",
        kind: "longtext",
        list: true,
        form: true,
      },
      {
        source: "type",
        label: "type",
        kind: "select",
        list: true,
        form: true,
        choices: [
          { value: "A", label: "A" },
          { value: "AAAA", label: "AAAA" },
          { value: "CAA", label: "CAA" },
          { value: "CNAME", label: "CNAME" },
          { value: "MX", label: "MX" },
          { value: "NS", label: "NS" },
          { value: "PTR", label: "PTR" },
          { value: "SOA", label: "SOA" },
          { value: "SRV", label: "SRV" },
          { value: "TXT", label: "TXT" },
        ],
        defaultValue: "A",
      },
      {
        source: "content",
        label: "content",
        kind: "text",
        list: true,
        form: true,
      },
      { source: "ttl", label: "ttl", kind: "text", list: true, form: true },
      { source: "prio", label: "prio", kind: "number", list: true, form: true },
      {
        source: "change_date",
        label: "change_date",
        kind: "text",
        list: true,
        form: false,
      },
      {
        source: "disabled",
        label: "disabled",
        kind: "boolean",
        list: true,
        form: true,
        defaultValue: false,
      },
      {
        source: "ordername",
        label: "ordername",
        kind: "text",
        list: false,
        form: true,
      },
      {
        source: "auth",
        label: "auth",
        kind: "boolean",
        list: true,
        form: true,
        defaultValue: true,
      },
    ],
    select: "*,domains(name)",
    searchFields: ["name", "content", "type", "domain_name_text"],
  },
  {
    name: "records",
    label: "Records",
    schema: "dns",
    notification: {
      verbose: true,
    },
    fields: [
      {
        source: "domain_id",
        label: "Domain",
        kind: "uuid",
        form: true,
        list: false,
        ref: {
          resource: "domains",
          optionText: "name",
          input: "autocomplete",
          schema: "dns",
        },
      },
      {
        source: "name",
        label: "Name",
        kind: "longtext",
        list: true,
        form: true,
      },
      {
        source: "type",
        label: "Type",
        kind: "select",
        list: true,
        form: true,
        choices: [
          { value: "A", label: "A" },
          { value: "AAAA", label: "AAAA" },
          { value: "CAA", label: "CAA" },
          { value: "CNAME", label: "CNAME" },
          { value: "MX", label: "MX" },
          { value: "NS", label: "NS" },
          { value: "PTR", label: "PTR" },
          { value: "SOA", label: "SOA" },
          { value: "SRV", label: "SRV" },
          { value: "TXT", label: "TXT" },
        ],
        defaultValue: "A",
      },
      {
        source: "content",
        label: "Content",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "ttl",
        label: "TTL",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "prio",
        label: "Priority",
        kind: "number",
        list: true,
        form: true,
      },
      {
        source: "change_date",
        label: "Change date",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "disabled",
        label: "Disabled",
        kind: "boolean",
        list: true,
        form: true,
        defaultValue: false,
      },
      {
        source: "ordername",
        label: "Ordername",
        kind: "text",
        list: false,
        form: true,
      },
      {
        source: "auth",
        label: "Auth",
        kind: "boolean",
        list: true,
        form: true,
        defaultValue: true,
      },
    ],
    // select: "*,domains(name)",
    searchFields: ["name", "content", "type"],
  },
];
